import React from 'react'

import OrganizationTableHeader from './OrganizationTableHeader';
import OrganizationEditUserSelect from './OrganizationEditUserSelect';

import {Card, CardBody, Table} from 'reactstrap';
import OrganizationUserActions from './OrganizationUserActions';

const OrganizationUserTable = (props) => {

  const { users, handleRemoveUserFromOrganization, userId, handleUpdateUserRoleInOrganization,
    currentOrganizationRole, setSelectedNewRole, selectedNewRole,
    showSelectMenuIndex, handleEditClick } = props;

  // Determine if we need the actions column
  const showActionsColumn = currentOrganizationRole === 'OWNER';
  
  // Only include the actions column header if needed
  const headers = showActionsColumn 
    ? ['Name', 'Email', 'Role', 'Actions'] 
    : ['Name', 'Email', 'Role'];

  const renderRows = (users) => {
    return (
      <tbody>
      {users.map((user, index) => (
          <tr key={index}>
            <td className="user-name-cell">
              {user.user.firstName} {user.user.lastName}
            </td>
            <td className="user-email-cell">
              {user.user.email}
            </td>
            <OrganizationEditUserSelect 
              setSelectedNewRole={setSelectedNewRole} 
              showSelectMenu={showSelectMenuIndex === index} 
              usersCurrentRole={user.role} 
              role={currentOrganizationRole} 
            />
            {user.user.id !== userId && currentOrganizationRole === 'OWNER' && <OrganizationUserActions
              index={index}
              showSelectMenu={showSelectMenuIndex === index}
              handleEditClick={() => handleEditClick(index)}
              handleRemoveUserFromOrganization={() => handleRemoveUserFromOrganization(user.userId)}
              handleUpdateUserRoleInOrganization={() => handleUpdateUserRoleInOrganization(user.userId, selectedNewRole)}
            />}
          </tr>
        )
      )}
      </tbody>
    )
  }

  return (
    <Card className="organization-users-card">
      <CardBody>
        <h3 className="subhead">Team Members</h3>
        <div className="table-responsive">
          <Table responsive>
            <OrganizationTableHeader headers={headers} />
            {!users.loading ? renderRows(users.users) : (
              <tbody>
                <tr>
                  <td colSpan={headers.length} className="text-center">
                    <div className="spinner-border text-success" role="status">
                      <span className="sr-only">Loading...</span>
                    </div>
                  </td>
                </tr>
              </tbody>
            )}
          </Table>
        </div>
      </CardBody>
    </Card>
  )
}

export default OrganizationUserTable